import { render, staticRenderFns } from "./S4.vue?vue&type=template&id=0a86fbb9&scoped=true&"
import script from "./S4.vue?vue&type=script&lang=js&"
export * from "./S4.vue?vue&type=script&lang=js&"
import style0 from "./S4.vue?vue&type=style&index=0&id=0a86fbb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a86fbb9",
  null
  
)

export default component.exports